export const competitors = {
  CONTINENTE: {
    code: 'continente',
    name: 'Continente',
    logo: 'https://static.wikia.nocookie.net/logopedia/images/7/7e/Continente_2005_Icon.svg',
    available: true
  },
  KUANTOKUSTA: {
    code: 'kuantokusta',
    name: 'Kuantokusta',
    logo: 'https://s1.kuantokusta.pt/img_upload/Repository/site/logo-v2-two-lines-black.png',
    available: true
  },
  WORTEN: {
    code: 'worten',
    name: 'Worten',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2b/Logotipo_Worten.jpg',
    available: true
  },
  AMAZON: {
    code: 'amazon_es',
    name: 'Amazon ES',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1206px-Amazon_logo.svg.png',
    available: true
  }
} as const;

export type CompetitorCode = typeof competitors[keyof typeof competitors]['code'];
export type CompetitorName = typeof competitors[keyof typeof competitors]['name'];
